import { useEffect } from "react";

const SCHEMA = {
  "@context": "https://schema.org",
  "@type": "MotorVehicleDealership",
  name: "Cascante Moto Rental",
  image:
    "https://customer-assets.emergentagent.com/job_cascante-moto/artifacts/23gakw74_WhatsApp%20Image%202026-05-12%20at%2011.57.53.jpeg",
  url: "https://www.cascantemotorental.com/",
  logo:
    "https://customer-assets.emergentagent.com/job_cascante-moto/artifacts/qwab89r8_image.png",
  telephone: "+50581017026",
  email: "Cascantemotorental@gmail.com",
  priceRange: "$$",
  description:
    "Motorcycle and scooter rentals in San Juan del Sur, Nicaragua. 135+ five-star reviews. Reliable bikes, honest prices, and local know-how.",
  address: {
    "@type": "PostalAddress",
    streetAddress: "San Juan del Sur",
    addressLocality: "San Juan del Sur",
    addressRegion: "Rivas",
    addressCountry: "NI",
  },
  geo: {
    "@type": "GeoCoordinates",
    latitude: 11.252,
    longitude: -85.8702,
  },
  openingHoursSpecification: [
    {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
      opens: "07:00",
      closes: "19:00",
    },
  ],
  sameAs: [
    "https://www.instagram.com/cascante_moto_rental",
    "https://www.facebook.com/Cascantemotorentals",
  ],
  aggregateRating: {
    "@type": "AggregateRating",
    ratingValue: "5.0",
    reviewCount: "135",
  },
  areaServed: [
    { "@type": "City", name: "San Juan del Sur" },
    { "@type": "City", name: "Rivas" },
    { "@type": "Country", name: "Nicaragua" },
  ],
};

export default function StructuredData() {
  useEffect(() => {
    const ID = "ld-json-localbusiness";
    if (document.getElementById(ID)) return;
    const s = document.createElement("script");
    s.id = ID;
    s.type = "application/ld+json";
    s.text = JSON.stringify(SCHEMA);
    document.head.appendChild(s);
  }, []);
  return null;
}
